export const CSA_PICTO_INDEX = 1;
export const SERVICE_PICTO_INDEX = 2;
export const LOCK_PICTO_INDEX = 4;

export const getCSAPicto = pictos => pictos && pictos[CSA_PICTO_INDEX];

export const getServicePicto = pictos => pictos && pictos[SERVICE_PICTO_INDEX];

export const getLockPicto = pictos => pictos && pictos[LOCK_PICTO_INDEX];
